export default __webpack_public_path__ + "static/media/spr-schema-1-light-large.d3e4caf3.png";